"use strict";
export const selectSearchHistory = (state) => {
  return state.searchHistory.results;
};
